import * as React from 'react';

import ShareButtonWithModalFromCommon from 'bundles/sharing-common/components/modal/ShareButtonWithModal';
import ShareCTAV2 from 'bundles/sharing-common/components/modal/buttons/cds/ShareCTAV2';
import type { SocialCaptions } from 'bundles/sharing-common/types/sharingSharedTypes';

type Props = {
  rootClassName: string;
  title: string;
  disableDescription: boolean;
  captions: SocialCaptions;
  utmMediumParam: string;
  utmContentParam: string;
  utmCampaignParam: string;
};

const ArticleShareButtonWithModal = (props: Props) => (
  <ShareButtonWithModalFromCommon tabbable={true} {...props}>
    <ShareCTAV2 />
  </ShareButtonWithModalFromCommon>
);

export default ArticleShareButtonWithModal;
